import { getOptionTypeValue } from 'app/components/filters/filters-panel/option-type-value';
import { Filter, OptionTypes, ConditionValueTypes } from 'app/components/filters/types';
import { getTextFieldConditionTypesValueData } from 'app/components/filters/filters-panel/filter-types/filter-text/text-field-data';

export const createConditionOptionTypeValue = (id: number, filter: Filter) => {
  const optionType = getOptionTypeValue(filter);

  const mapped = {
    [OptionTypes.NotSpecified]: ConditionValueTypes.notSpecified
  };

  const newConditionValue = filter.advancedField && {
    id,
    myValue: false,
    periodPredef: { v: 0 },
    ...getTextFieldConditionTypesValueData(filter.advancedField, mapped[optionType])
  };

  return optionType && mapped[optionType] && [newConditionValue];
};
